// Utilitário para otimizar Back/Forward Cache (BFCache)
export const initializeBFCache = () => {
  // Melhora o comportamento do BFCache
  window.addEventListener('beforeunload', () => {
    // Não realizar operações que impedem BFCache
    // Como setInterval, setTimeout longos, etc.
  });

  // Detecta quando a página volta do BFCache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Página restaurada do BFCache
      console.log('Página restaurada do BFCache - performance otimizada!');
      
      // Reativar qualquer funcionalidade necessária
      // que pode ter sido pausada
    }
  });

  // Limpa recursos que podem impedir BFCache
  window.addEventListener('pagehide', (event) => {
    if (event.persisted) {
      // Página indo para BFCache
      // Limpar timers, conexões, etc.
      clearAllTimers();
    }
  });
};

// Função para limpar timers e recursos
const clearAllTimers = () => {
  // Limpa todos os intervalos ativos
  const highestTimeoutId = setTimeout(() => {}) as unknown as number;
  for (let i = 0; i < highestTimeoutId; i++) {
    clearTimeout(i);
  }
  
  const highestIntervalId = setInterval(() => {}) as unknown as number;
  for (let i = 0; i < highestIntervalId; i++) {
    clearInterval(i);
  }
  clearInterval(highestIntervalId);
};

// Função para verificar se o BFCache está funcionando
export const checkBFCacheSupport = () => {
  return 'onpageshow' in window && 'onpagehide' in window;
}; 